var API_ENDPOINTS = {
  prod: {
    LISTING_CONTACT: '/cms-constellation/api/listing-contact/'
  },
  dev: {
    LISTING_CONTACT: '/api/listing-contact/'
  },
  test: {
    LISTING_CONTACT: '/cms-constellation/api/listing-contact/'
  }
};
var API_ENDPOINTS$1 = API_ENDPOINTS;

export { API_ENDPOINTS$1 as default };
